<template>
  <div class="shippingDetails">
    <header class="fixed_Back_header flx">
      <div class="menu flx">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="16"
          viewBox="0 0 20 16"
          @click="goBack()"
        >
          <g fill="#FFF" fill-rule="evenodd">
            <path
              d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
            />
            <path
              d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
            />
          </g>
        </svg>
        <h3 style="visibility:hidden">{{$t("shippingDetail")}}</h3>
      </div>
    </header>
    <section class="main_content">
      <div class="product-card" v-if="subOrderDetails">
        <span
          class="product-img"
          v-if="subOrderDetails.itemImage"
          @click="goToProductDetail(subOrderDetails.saleReferenceID,'NORMAL')"
        >
          <img :src="subOrderDetails.itemImage" alt="item-image" />
        </span>
        <div class="product-detail">
          <div class="product-title">
            <h4>{{subOrderDetails.itemName}}</h4>
          </div>
          <div class="color-size">
            <span class="product-color" v-if="subOrderDetails.color">
              {{$t('color')}} :&nbsp;
              <span class="colour">
                <span>{{subOrderDetails.color}}</span>
              </span>
            </span>
            <span class="product-sz" v-if="subOrderDetails.size">
              {{$t('size')}} :&nbsp;
              <span class="size">{{subOrderDetails.size}}</span>
            </span>
          </div>
          <p
            class="share-section"
            @click="shareFunc(allDetails.shareMessageUrl,allDetails.itemMediaDTOList[0].original, allDetails.saleReferenceID)"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17">
              <path
                fill="none"
                fill-rule="nonzero"
                stroke="#0091FF"
                stroke-width="1.4"
                d="M14 8.496L8.597 2v3.875H7.45C3.887 5.875 1 9.041 1 12.946V15l.51-.613c1.735-2.084 4.19-3.271 6.762-3.271h.325v3.875L14 8.496z"
              />
            </svg>
            {{$t('shareThisItem')}}
          </p>
        </div>
      </div>
      <div class="order-notify-msg">
        <p
          v-if="orderDetails.eligibleforReturn && orderDetails.orderReturnDTO == null"
        >{{$t('returnTillDate',{eligibleReturnDate:orderDetails.eligibleforReturnDate})}}</p>
        <p
          v-if="!orderDetails.eligibleforReturn && orderDetails.orderReturnDTO == null"
        >{{$t('orderisnotreturnable')}}</p>
        <p
          v-if="orderDetails.orderDate"
        >{{ orderDetails.orderDate.slice(0, orderDetails.orderDate.indexOf(',')) }} {{$t('onThisDateBoughtProduct')}}</p>
      </div>
      <ul class="action-on-delivery">
        <router-link tag="li" :to="{ path: '/detail/'+ subOrderDetails.saleReferenceID}">
          {{$t('reOrder')}}
          <span class="go_detail_listing">
            <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
          </span>
        </router-link>
        <router-link tag="li" :to="{ path: '/order-feedback/' + orderDetails.orderId}">
          {{$t('howsYourProduct')}}
          <span class="go_detail_listing">
            <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
          </span>
        </router-link>
        <router-link
          tag="li"
          :to="{ path: '/ProductReturn/' + this.$route.params.orderId}"
          v-if="orderDetails.eligibleforReturn"
        >
          {{$t('returnItem')}}
          <span class="go_detail_listing">
            <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
          </span>
        </router-link>
        <router-link tag="li" :to="{ path: '/shippingDetails/' + orderDetails.orderId}">
          {{$t('seeDetailOfProduct')}}
          <span class="go_detail_listing">
            <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
          </span>
        </router-link>
        <router-link tag="li" :to="{ path: '/track-order/' + orderDetails.orderId}">
          {{$t('trackOrder')}}
          <span class="go_detail_listing">
            <img src="../../assets/images/icons/right-arrow.png" alt style="height: 10px;" />
          </span>
        </router-link>
      </ul>
    </section>
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import constant from "../../utils/constant";
import "../../assets/css/order-history.scss";
export default {
  name: "DeliverOrder",
  data() {
    return {
      orderDetails: {},
      showCancel: true,
      subOrderDetails: {},
      loading: false,
      orderId: 0,
      CancelModal: false,
      isTrackOrder: false,
      orderSourceType: null,
      allDetails: {},
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getProductDetail() {
      if (this.$route.query.source) {
        this.orderSourceType = this.$route.query.source;
      } else {
        this.orderSourceType = null;
      }
      const obj = {
        saleReferenceID: this.subOrderDetails.saleReferenceID,
        referralUserId: this.$route.params.encodedId,
        orderSourceType: this.orderSourceType,
        cutPrice: null,
      };
      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: obj,
        })
        .then((data) => {
          this.loading = false;
          this.allDetails = data.data;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      if (this.$cookie.get("X-Auth-Id") != null) {
        try {
          JSBridgePlugin.fireEvents("Delivered_Product_Shared");
        } catch (err) {
          console.log(err);
        }
        this.loading = true;
        this.$store
          .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID })
          .then((data) => {
            this.shareLinkData = data.data;
            this.loading = false;
            shareMessage = data.data.shareMessage;
            const obj = {
              message: shareMessage,
              imageUrl: shareImage,
            };
            try {
              JSBridgePlugin.share(JSON.stringify(obj));
            } catch (err) {
              console.log(err);
              window.open("whatsapp://send?text=" + shareMessage);
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log(err);
          });
      } else {
        try {
          _prompt_login.promptLogin = (res) => {
            if (res == "success") {
              console.log(res);
            } else {
              this.loading = false;
            }
          };
          JSBridgePlugin.promptLogin("_prompt_login.promptLogin");
        } catch (err) {
          this.loading = false;
          console.log(err);
        }
      }
    },
    getOrdersById() {
      this.loading = true;
      this.$store
        .dispatch({
          type: "orderById",
          payload: this.$route.params.orderId,
        })
        .then((data) => {
          this.orderDetails = data.data;

          if (
            this.orderDetails &&
            this.orderDetails.subOrderDTOList &&
            this.orderDetails.subOrderDTOList.length > 0
          ) {
            this.subOrderDetails = this.orderDetails.subOrderDTOList[0];
            this.getProductDetail();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },

    goToProductDetail(productSrId, type) {
      this.$cookie.delete("type");
      this.$cookie.set("type", type);
      this.$router.onError((err) => {
        if (/loading chunk \d* failed./i.test(err.message)) {
          window.location.reload();
        }
      });
      this.$router.push("/detail/" + productSrId);
    },
  },
  mounted() {
    if (this.$route.params.orderId) {
      this.getOrdersById();
    }
  },
};
</script>